import React, { useState } from 'react';

// === DUMMY PROPERTY DATA ===
const properties = [
  {
    id: "PROP01",
    title: "Modern 3BHK Luxury Apartment",
    location: "Sector 150, Noida",
    price: "₹1.25 Cr",
    type: "Apartment",
    beds: 3,
    baths: 3,
    sqft: "1,550",
    img: "https://images.unsplash.com/photo-1545324418-cc1a3fa10c00?q=80&w=600&auto=format&fit=crop"
  },
  {
    id: "PROP02",
    title: "Premium Independent Villa",
    location: "Golf Course Ext. Road, Gurugram",
    price: "₹4.50 Cr",
    type: "Villa",
    beds: 4,
    baths: 5,
    sqft: "3,200",
    img: "https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?q=80&w=600&auto=format&fit=crop"
  },
  {
    id: "PROP03",
    title: "Spacious 2BHK Builder Floor",
    location: "Dwarka Sector 12, Delhi",
    price: "₹85 Lacs",
    type: "Builder Floor",
    beds: 2,
    baths: 2,
    sqft: "1,100",
    img: "https://images.unsplash.com/photo-1560448204-e02f11c3d0e2?q=80&w=600&auto=format&fit=crop"
  },
  {
    id: "PROP04",
    title: "Fully Furnished Penthouse",
    location: "Marine Drive, Mumbai",
    price: "₹8.5 Cr",
    type: "Penthouse",
    beds: 4,
    baths: 4,
    sqft: "4,000",
    img: "https://images.unsplash.com/photo-1512917774073-ea26a0a7342a?q=80&w=600&auto=format&fit=crop"
  },
  {
    id: "PROP05",
    title: "Commercial Office Space",
    location: "Cyber City, Gurugram",
    price: "₹2.2 Cr",
    type: "Commercial",
    beds: "-",
    baths: 2,
    sqft: "2,500",
    img: "https://images.unsplash.com/photo-1497366216548-37526070297c?q=80&w=600&auto=format&fit=crop"
  },
  {
    id: "PROP06",
    title: "Affordable 2BHK Apartment",
    location: "Rajarhat, Bengaluru",
    price: "₹65 Lacs",
    type: "Apartment",
    beds: 2,
    baths: 2,
    sqft: "950",
    img: "https://images.unsplash.com/photo-1522708323590-d24dbb6b0267?q=80&w=600&auto=format&fit=crop"
  }
];

const RealEstateBasic: React.FC = () => {
  const [isSubmitted, setIsSubmitted] = useState(false);

  const handleLeadSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitted(true);
    setTimeout(() => setIsSubmitted(false), 4000);
  };

  return (
    <div className="min-h-screen bg-slate-50 text-slate-800 font-sans scroll-smooth selection:bg-amber-200">
      
      {/* 1. TOP BAR */}
      <div className="bg-slate-900 text-slate-300 text-[10px] sm:text-xs py-2 px-6 flex flex-col sm:flex-row justify-between items-center tracking-widest uppercase">
        <div className="flex gap-4">
          <span>RERA Registered Agent</span>
          <span className="hidden sm:inline">|</span>
          <span>10+ Years of Trust</span>
        </div>
        <div className="flex gap-4 mt-2 sm:mt-0 font-bold text-amber-500">
          <span>📞 +91 98765 43210</span>
        </div>
      </div>

      {/* 2. NAVBAR */}
      <nav className="bg-white sticky top-0 z-50 shadow-md border-b border-slate-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 h-20 flex items-center justify-between">
          <div className="flex items-center gap-2 cursor-pointer" onClick={() => window.scrollTo(0,0)}>
            <span className="text-3xl text-blue-700">🏢</span>
            <div className="leading-tight">
              <span className="text-2xl font-black text-slate-900 tracking-tight block uppercase">Prime Estate</span>
              <span className="text-[9px] uppercase tracking-widest text-slate-500 font-bold block">Your Property Partner</span>
            </div>
          </div>
          
          <div className="hidden md:flex gap-8 text-xs font-bold uppercase tracking-widest text-slate-600">
            <a href="#properties" className="hover:text-blue-700 transition">Properties</a>
            <a href="#about" className="hover:text-blue-700 transition">Why Us</a>
            <a href="#contact" className="hover:text-blue-700 transition">Contact</a>
          </div>

          <a href="#contact" className="bg-blue-700 text-white px-6 py-2.5 rounded text-xs font-bold uppercase tracking-widest hover:bg-blue-800 transition shadow-lg hidden sm:block">
            Get a Call Back
          </a>
        </div>
      </nav>

      {/* 3. HERO SECTION */}
      <header className="relative bg-slate-900 py-20 lg:py-32 px-6 overflow-hidden">
        <div className="absolute inset-0">
          <img 
            src="https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?q=80&w=1600&auto=format&fit=crop" 
            alt="Real Estate Hero" 
            className="w-full h-full object-cover opacity-40"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-slate-900 via-slate-900/60 to-transparent"></div>
        </div>
        
        <div className="max-w-7xl mx-auto relative z-10 text-center space-y-6">
          <span className="inline-block bg-amber-500 text-slate-900 px-4 py-1.5 rounded-full text-xs font-black uppercase tracking-widest shadow-lg">
            Find Your Dream Home Today
          </span>
          <h1 className="text-4xl md:text-6xl lg:text-7xl font-black text-white leading-tight">
            Premium Properties. <br className="hidden md:block"/> <span className="text-blue-400">Honest Deals.</span>
          </h1>
          <p className="text-slate-300 text-base md:text-xl max-w-2xl mx-auto font-light">
            We help you buy, sell, and rent properties with 100% transparency. Explore the best deals in top locations without any hassle.
          </p>
          <div className="pt-6">
            <a href="#properties" className="inline-block bg-blue-600 text-white px-10 py-4 rounded text-sm font-bold uppercase tracking-widest hover:bg-blue-500 transition shadow-2xl">
              View Available Properties
            </a>
          </div>
        </div>
      </header>

      {/* 4. PROPERTIES LISTING SECTION (The Core) */}
      <section id="properties" className="py-24 px-4 sm:px-6 bg-slate-100">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-16">
            <span className="text-blue-600 font-bold uppercase tracking-widest text-xs">Featured Listings</span>
            <h2 className="text-3xl md:text-4xl font-black text-slate-900 mt-2">Properties For Sale</h2>
            <p className="text-slate-500 mt-4 max-w-xl mx-auto">Browse through our handpicked selection of premium apartments, villas, and commercial spaces.</p>
          </div>

          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-8">
            {properties.map((prop) => (
              <div key={prop.id} className="bg-white rounded-xl overflow-hidden shadow-md border border-slate-200 hover:shadow-2xl transition duration-300 group">
                {/* Property Image */}
                <div className="relative h-60 overflow-hidden">
                  <img src={prop.img} alt={prop.title} className="w-full h-full object-cover group-hover:scale-105 transition duration-700"/>
                  <div className="absolute top-4 left-4 bg-slate-900 text-white text-[10px] font-bold uppercase tracking-widest px-3 py-1 rounded shadow-md">
                    {prop.type}
                  </div>
                  <div className="absolute bottom-4 right-4 bg-amber-500 text-slate-900 text-sm font-black px-3 py-1 rounded shadow-lg">
                    {prop.price}
                  </div>
                </div>
                
                {/* Property Details */}
                <div className="p-6">
                  <h3 className="text-lg font-black text-slate-900 mb-1 line-clamp-1">{prop.title}</h3>
                  <p className="text-sm text-slate-500 flex items-center gap-2 mb-4">
                    <span className="text-blue-600">📍</span> {prop.location}
                  </p>
                  
                  <div className="grid grid-cols-3 gap-4 border-t border-slate-100 pt-4 mb-6">
                    <div className="text-center">
                      <p className="text-slate-400 text-[10px] uppercase font-bold tracking-widest">Beds</p>
                      <p className="font-bold text-slate-800">{prop.beds}</p>
                    </div>
                    <div className="text-center border-l border-r border-slate-100">
                      <p className="text-slate-400 text-[10px] uppercase font-bold tracking-widest">Baths</p>
                      <p className="font-bold text-slate-800">{prop.baths}</p>
                    </div>
                    <div className="text-center">
                      <p className="text-slate-400 text-[10px] uppercase font-bold tracking-widest">Sq.Ft.</p>
                      <p className="font-bold text-slate-800">{prop.sqft}</p>
                    </div>
                  </div>
                  
                  <a href="#contact" className="block text-center w-full bg-slate-50 border border-slate-200 text-slate-700 py-3 rounded text-xs font-bold uppercase tracking-widest hover:bg-blue-600 hover:text-white hover:border-blue-600 transition">
                    Enquire Now
                  </a>
                </div>
              </div>
            ))}
          </div>
          
          <div className="text-center mt-12">
             <a href="#contact" className="inline-block text-blue-600 font-bold uppercase tracking-widest text-sm hover:underline">Can't find what you're looking for? Let us know ➔</a>
          </div>
        </div>
      </section>

      {/* 5. ABOUT / WHY US SECTION */}
      <section id="about" className="py-20 px-6 bg-white border-b border-slate-100">
        <div className="max-w-5xl mx-auto text-center space-y-12">
          <h2 className="text-3xl font-black text-slate-900">Why Choose Prime Estate?</h2>
          <div className="grid sm:grid-cols-3 gap-8">
            <div className="p-6">
              <span className="text-5xl block mb-4">🤝</span>
              <h3 className="text-lg font-bold mb-2">100% Transparency</h3>
              <p className="text-slate-500 text-sm">No hidden charges or false promises. We deal with verified and RERA registered properties only.</p>
            </div>
            <div className="p-6">
              <span className="text-5xl block mb-4">⚡</span>
              <h3 className="text-lg font-bold mb-2">Fast Processing</h3>
              <p className="text-slate-500 text-sm">From property visits to loan approvals and registry, our team handles all the paperwork.</p>
            </div>
            <div className="p-6">
              <span className="text-5xl block mb-4">💰</span>
              <h3 className="text-lg font-bold mb-2">Best Price Guarantee</h3>
              <p className="text-slate-500 text-sm">We negotiate directly with builders and owners to get you the most competitive market rates.</p>
            </div>
          </div>
        </div>
      </section>

      {/* 6. LEAD GENERATION FORM & CONTACT (CRUCIAL SECTION) */}
      <section id="contact" className="py-24 px-4 sm:px-6 bg-slate-900 text-white">
        <div className="max-w-7xl mx-auto grid lg:grid-cols-2 gap-16 items-center">
          
          {/* Info Side */}
          <div className="space-y-8">
            <span className="text-amber-500 font-bold uppercase tracking-widest text-xs">Let's Connect</span>
            <h2 className="text-4xl md:text-5xl font-black leading-tight">Ready to buy your <br/> dream property?</h2>
            <p className="text-slate-400 text-lg">Leave your details below and our property expert will call you within 30 minutes to discuss your requirements.</p>
            
            <div className="space-y-6 pt-4">
              <div className="flex gap-4 items-center">
                <div className="w-12 h-12 bg-slate-800 rounded flex items-center justify-center text-xl">📍</div>
                <div>
                  <h4 className="font-bold text-slate-200">Office Address</h4>
                  <p className="text-slate-400 text-sm">1st Floor, Landmark Tower, Connaught Place, New Delhi</p>
                </div>
              </div>
              <div className="flex gap-4 items-center">
                <div className="w-12 h-12 bg-slate-800 rounded flex items-center justify-center text-xl">📞</div>
                <div>
                  <h4 className="font-bold text-slate-200">Call Us Directly</h4>
                  <p className="text-slate-400 text-sm">+91 98765 43210 (9 AM - 8 PM)</p>
                </div>
              </div>
            </div>
          </div>

          {/* Lead Gen Form */}
          <div className="bg-white text-slate-800 p-8 sm:p-10 rounded-2xl shadow-2xl">
            <h3 className="text-2xl font-black mb-6">Schedule a Free Site Visit</h3>
            
            {isSubmitted ? (
              <div className="bg-green-50 border border-green-200 text-green-700 p-8 rounded-xl text-center h-64 flex flex-col justify-center items-center">
                <span className="text-5xl mb-4 block">✅</span>
                <h4 className="font-black text-xl mb-2">Request Received!</h4>
                <p className="text-sm">Our agent will call you shortly to assist you.</p>
              </div>
            ) : (
              <form onSubmit={handleLeadSubmit} className="space-y-5">
                <div>
                  <label className="block text-[10px] font-bold text-slate-500 uppercase tracking-wider mb-2">Your Name</label>
                  <input required type="text" className="w-full bg-slate-50 border border-slate-200 px-4 py-3 rounded focus:outline-none focus:border-blue-600 transition" placeholder="John Doe" />
                </div>
                <div>
                  <label className="block text-[10px] font-bold text-slate-500 uppercase tracking-wider mb-2">Mobile Number</label>
                  <input required type="tel" className="w-full bg-slate-50 border border-slate-200 px-4 py-3 rounded focus:outline-none focus:border-blue-600 transition" placeholder="+91 00000 00000" />
                </div>
                <div className="grid grid-cols-2 gap-4">
                  <div>
                    <label className="block text-[10px] font-bold text-slate-500 uppercase tracking-wider mb-2">Looking For</label>
                    <select className="w-full bg-slate-50 border border-slate-200 px-4 py-3 rounded focus:outline-none focus:border-blue-600 transition text-slate-700">
                      <option>Buy Property</option>
                      <option>Rent Property</option>
                      <option>Sell Property</option>
                    </select>
                  </div>
                  <div>
                    <label className="block text-[10px] font-bold text-slate-500 uppercase tracking-wider mb-2">Property Type</label>
                    <select className="w-full bg-slate-50 border border-slate-200 px-4 py-3 rounded focus:outline-none focus:border-blue-600 transition text-slate-700">
                      <option>2 BHK / 3 BHK</option>
                      <option>Villa / Independent</option>
                      <option>Commercial / Shop</option>
                      <option>Plot / Land</option>
                    </select>
                  </div>
                </div>
                <button type="submit" className="w-full bg-blue-600 text-white font-black uppercase tracking-widest py-4 rounded hover:bg-blue-700 transition shadow-lg mt-2 text-sm">
                  Get a Call Back
                </button>
              </form>
            )}
          </div>

        </div>
      </section>

      {/* 7. FOOTER */}
      <footer className="bg-slate-950 text-slate-500 py-10 px-6 text-center text-sm border-t border-slate-800">
        <div className="max-w-7xl mx-auto flex flex-col md:flex-row justify-between items-center gap-4">
          <div className="flex items-center gap-2">
            <span className="text-xl">🏢</span>
            <span className="text-lg font-black text-slate-300 uppercase tracking-tight">Prime Estate</span>
          </div>
          <p className="text-[10px] font-bold uppercase tracking-widest">© {new Date().getFullYear()} Prime Estate Properties. All Rights Reserved.</p>
          <p className="text-[10px] uppercase tracking-widest font-bold text-blue-600">Basic Portfolio Demo</p>
        </div>
      </footer>

    </div>
  );
};

export default RealEstateBasic;